import React from 'react';
import { Link } from 'react-router-dom';
import useFleetStore from '../../stores/useFleetStore';
import Panel from '../../components/ui/Panel';
import EmptyState from '../../components/ui/EmptyState';
import Tag from '../../components/ui/Tag';
import { CATEGORY } from '../../components/ui/categoryColors';

const FlagSummaryModule = () => {
  const flags = useFleetStore((state) => state.flags);

  if (flags.length === 0) {
    return (
      <Panel label="Flag summary">
        <EmptyState variant="area">No active flags</EmptyState>
      </Panel>
    );
  }

  // Group flags by description/category
  const categories = flags.reduce((acc, flag) => {
    const cat = flag.descript || 'Uncategorized';
    acc[cat] = (acc[cat] || 0) + 1;
    return acc;
  }, {});

  const sorted = Object.entries(categories).sort((a, b) => b[1] - a[1]);

  const FLAG_HUES = ['orange', 'red', 'yellow', 'purple', 'blue', 'pink', 'teal', 'indigo'];
  const flagColour = (i) => CATEGORY[FLAG_HUES[i % FLAG_HUES.length]].mark.oklch;

  return (
    <Panel
      title="Flag Summary"
      titleStyle="section"
      accent="orange"
      lit
      level={3}
      actions={<Tag size="sm" hex={CATEGORY.orange.ink.hex}>{flags.length} total</Tag>}
    >
      {/* Stacked bar */}
      <div className="flex rounded-full h-3 overflow-hidden mb-4 bg-gray-900/60">
        {sorted.map(([cat, count], i) => (
          <div
            key={cat}
            className="transition-all duration-700"
            style={{ background: flagColour(i), width: `${(count / flags.length) * 100}%`, minWidth: '4px' }}
            title={`${cat}: ${count}`}
          />
        ))}
      </div>

      {/* Legend list */}
      <div className="space-y-1.5">
        {sorted.slice(0, 8).map(([cat, count], i) => (
          <div key={cat} className="flex items-center gap-2.5">
            <span className="w-2.5 h-2.5 rounded-sm flex-shrink-0" style={{ background: flagColour(i) }} />
            <span className="text-xs text-on-surface flex-1 truncate">{cat}</span>
            <span className="text-xs text-on-surface-variant tabular-nums font-medium">{count}</span>
          </div>
        ))}
        {sorted.length > 8 && (
          <div className="text-[10px] text-on-surface-disabled pl-5">+{sorted.length - 8} more categories</div>
        )}
      </div>
    </Panel>
  );
};

export default FlagSummaryModule;
